const Size = {
  'S': 'S',
  'M': 'M',
};
const LabelPosition = {
  TOP: 'TOP',
  LEFT: 'LEFT',
};
export {
  Size,
  LabelPosition
};